import React, { useEffect, useState } from "react";
import "./styles.css";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  Dropdown,
  Field,
  Link,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Spinner,
  Toast,
  Toaster,
  ToastTitle,
  ToastTrigger,
  useId,
  useToastController,
} from "@fluentui/react-components";
import ClientSelection from "./Clients";
import apiServices from "../../../service";
import { ChevronDownRegular } from "@fluentui/react-icons";
import MaterialReactTable, { MRT_ColumnDef } from "material-react-table";
import OverlayLoader from "../../../components/OverlayLoader";
import store from "../../../redux/store";
import axios from "axios";
import { useDispatch } from "react-redux";
import ASCButton from "../../../components/Button";
type selectedValue = {
  customer_id: string;
  first_names: string;
  last_name: string;
};
const LetterGeneration = () => {
  const [showClientSelection, setShowClientSelection] = useState(false);
  const [clients, setClients] = useState<selectedValue[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectedClient, setSelectedClient] = useState<selectedValue[]>([]);
  const [templateListing, setTemplateListing] = useState<any>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<any>("");
  const [openSampleTemplate, setOpenSampleTemplate] = useState<boolean>(false);
  const [selectedTemplateCode, setSelectedTemplateCode] = useState<any>("");
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [sampleTemplate, setSampleTemplate] = useState<any>([]);
  const dispatch = useDispatch();
  const toasterId = useId("toaster");
  const { dispatchToast } = useToastController(toasterId);

  const notify = (message?: any, type?: any) =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Link>Dismiss</Link>
            </ToastTrigger>
          }
        >
          {message}
        </ToastTitle>
      </Toast>,
      { intent: type ? type : "success" }
    );
  const resetAll = () => {
    setSelectedClient([]);
    setSelectedTemplateCode([]);
    setSelectedTemplate("");
    setSelectedOptions([]);
  };
  const getLetterList = () => {
    apiServices.TemplateEngine.getLetterTemplate().then((res) => {
      const filteredTemplates = res.data
        .filter((item: any) => item.status === "Completed" && item.code !== null)
        .map((item: any) => ({
          title: item.title,
          code: item.code,
        }));

      setTemplateListing(filteredTemplates);
    });
  };

  useEffect(() => {
    getLetterList();
  }, []);
  const handleTemplateClick = (title: string, code: string) => {
    setSelectedTemplate(title);
    setSelectedTemplateCode(code);
  };

  const renderMenuItems = templateListing.map((item: any) => (
    <MenuItem
      key={item.title}
      onClick={() => handleTemplateClick(item.title, item.code)}
    >
      {item.title}
    </MenuItem>
  ));

  const handleClientSelection = (selectedIds: string[]) => {
    const selectedClients = clients.filter((client: any) =>
      selectedIds.includes(client?.customer_id)
    );

    if (selectedClients.length > 0) {
      setSelectedOptions(selectedClients.map((client) => client?.customer_id));
      setSelectedClient(selectedClients);
    }
  };

  let timestamp: any = new Date();
  timestamp = timestamp.toISOString();
  const generateNonce = () => {
    const CryptoJS = require("crypto-js");
    const requestData = {};
    const hash = CryptoJS.SHA256(`${requestData}${timestamp}`);
    return hash.toString(CryptoJS.enc.Hex);
  };
  const nonce = generateNonce();

  const generateLetter = async () => {
    try {
      setLoading(true);

      const requestData = {
        customerIds: selectedOptions,
      };

      const token = store.getState().authUser.userToken;
      const userId = store.getState().authUser.userId;
      const refreshToken = store.getState().authUser.refreshToken;

      const fileExtension = "zip";

      const url = `${process.env.REACT_APP_BASE_URL}report/new/custom/${selectedTemplateCode}`;

      const response = await axios.post(url, requestData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Nonce": nonce,
          "X-Timestamp": timestamp,
          UserId: userId,
          RefreshToken: refreshToken,
        },
        responseType: "blob",
      });

      const fileUrl = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = fileUrl;

      link.setAttribute("download", `${selectedTemplateCode}.${fileExtension}`);

      document.body.appendChild(link);
      link.click();
      notify("Letter Generated Succesfully", "success");

      window.URL.revokeObjectURL(fileUrl);
      document.body.removeChild(link);
    } catch (error: any) {
      notify(error.message, "error");
      console.error("Error generating the letter:", error);
    } finally {
      setLoading(false);
      resetAll();
    }
  };

  const columnsData: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "title",
      header: "Title",
    },
    {
      accessorKey: "description",
      header: "Description",
    },
    {
      accessorKey: "signedUrl",
      header: "Link",
      Cell: ({ row }: any) => (
        <>
          <a href={row.original.signedUrl} style={{ textDecoration: "none" }}>
            {row.original.title} - {row.original.templateFilePath}
          </a>{" "}
        </>
      ),
    },
  ];

  const handleRowSelection = (row: any) => {
    setSelectedRow(row.original);
  };
  const getClientPlaceholder = () => {
    if (selectedClient.length === 0) {
      return "Select a Client / Multiple Clients";
    } else if (selectedClient.length === 1) {
      return `${selectedClient[0].first_names} ${selectedClient[0].last_name}`;
    } else if (selectedClient.length === 2) {
      return `${selectedClient[0].first_names} ${selectedClient[0].last_name}, ${selectedClient[1].first_names} ${selectedClient[1].last_name}`;
    } else {
      return `${selectedClient[0].first_names}, ${selectedClient[1].first_names
        } + ${selectedClient.length - 2} others`;
    }
  };

  return (
    <div>
      <OverlayLoader isLoading={loading} />
      <Toaster
        toasterId={toasterId}
        position="top-end"
        pauseOnHover
        pauseOnWindowBlur
        timeout={1000}
      />
      <div className="main-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Field label="Select Template :">
              <Menu>
                <MenuTrigger disableButtonEnhancement>
                  <Button
                    shape="rounded"
                    disabled={loading}
                    style={{
                      fontWeight: "normal",
                      width: "350px",
                      color: "#606060",
                      border: "1px solid grey",
                      justifyContent: "flex-start",
                      textAlign: "left",
                      paddingLeft: "10px",
                      maxHeight: "40vh"
                    }}
                  >
                    <span style={{ flexGrow: 1, textAlign: "left" }}>
                      {selectedTemplate || "Select Template"}
                    </span>
                    {loading ? <Spinner size="tiny" /> : <ChevronDownRegular />}
                  </Button>
                </MenuTrigger>
                <MenuPopover
                  style={{
                    minWidth: "350px",
                    // minHeight: "fit-content",
                    maxHeight: "40vh",
                    overflowX: "hidden",
                    overflowY: "scroll",
                  }}
                >
                  <MenuList
                    style={{
                      minWidth: "350px",
                      minHeight: "fit-content",
                      maxHeight: "40vhx",
                    }}
                  >
                    {renderMenuItems}
                  </MenuList>
                </MenuPopover>
              </Menu>
            </Field>
          </div>
          <div>
            <ASCButton
              shape="rounded"
              disabled={
                !(
                  selectedOptions?.length > 0 &&
                  selectedTemplateCode?.length > 0
                )
              }
              appearance="primary"
              className="asc-button-primary"
              onClick={generateLetter}
              label="Generate"
            />
          </div>
        </div>
        <div>
          <Field label="Select Client(s) :">
            <Dropdown
              style={{ width: "350px" }}
              placeholder={getClientPlaceholder()}
              onClick={() => setShowClientSelection(true)}
              disabled={selectedTemplate.length === 0}
            />
          </Field>
        </div>
      </div>
      <Dialog
        modalType="alert"
        open={showClientSelection}
        onOpenChange={(event, data) => setShowClientSelection(data.open)}
      >
        <DialogSurface>
          <DialogBody>
            <span className="mui-table">Client Selection</span>
            <DialogContent>
              <ClientSelection
                onSelect={handleClientSelection}
                handleClientSelection={handleClientSelection}
                setClientList={setClients}
              />
            </DialogContent>
            <DialogActions>
              <ASCButton
                shape="rounded"
                size="medium"
                appearance="secondary"
                onClick={() => {
                  setShowClientSelection(false);
                  setSelectedClient([]);
                  setSelectedOptions([]);
                }}
                label="Close"
              />
              <ASCButton
                shape="rounded"
                className="asc-button-primary"
                appearance="primary"
                onClick={() => setShowClientSelection(false)}
                size="medium"
                label="Select"
              />
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>

      <Dialog modalType="alert" open={openSampleTemplate}>
        <DialogSurface>
          <DialogBody>
            <span style={{ fontWeight: 600, fontSize: "16px" }}>
              Sample Templates{" "}
            </span>
            <DialogContent>
              <MaterialReactTable
                columns={columnsData}
                data={sampleTemplate}
                manualPagination
                enableGlobalFilter={true}
                enableColumnActions={false}
                enableColumnFilters={true}
                enableRowSelection
                muiTableBodyRowProps={({ row }) => ({
                  onClick: () => handleRowSelection(row),
                })}
                muiTableBodyCellProps={({ column }) => ({
                  style: {
                    padding: "6px 12px",
                    fontSize: "0.875rem",
                  },
                })}
                enableMultiRowSelection={false}
                enableFullScreenToggle={false}
                muiTablePaginationProps={{
                  showFirstButton: false,
                  showLastButton: false,
                }}
                onGlobalFilterChange={(text: string) => {
                  if (text) {
                    setSearchText(text);
                  } else {
                    setSearchText("");
                  }
                }}
              />
            </DialogContent>
            <DialogActions>
              <ASCButton
                shape="rounded"
                size="medium"
                onClick={() => {
                  setOpenSampleTemplate(false);
                  setSelectedRow(null);
                }}
                label="Close"
              />
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
};

export default LetterGeneration;
